// extracted by mini-css-extract-plugin
module.exports = {"navigation":"cloudProviderNavigation_navigation__1NB8K"};